import { routePaths } from "@/config";
import { Navigate, Route, Routes } from "react-router-dom";
import LProfile from "../layouts/Profile.layout";
import Home from "../pages/Home.page";
import Users from "../pages/Users.page";
import UsersLogs from "../pages/UsersLogs.page";

export const ProfileRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="" element={<LProfile />}>
                <Route index element={<Home />} />
                <Route path={routePaths.profileChildren.home} element={<Home />} />
                <Route path={routePaths.profileChildren.users} element={<Users />} />
                <Route path={routePaths.profileChildren.logs} element={<UsersLogs />} />
                <Route path="/*" element={<Navigate to={`${routePaths.profileChildren.homeAbsolute}`} />} />
            </Route>
        </Routes>
    );
};